<script>
import useSharedData from "@/use/SharedData";
import useTools from "@/use/Tools";
import {computed, ref, watch} from "vue";
import useSharedSelectData from "@/use/SharedSelectData";
import {useWorkerBalanceStore} from "@/stores/WorkerBalance";
import {storeToRefs} from "pinia";
import WorkerBalanceInOutDataTable from "@/views/WorkerBalance/Components/WorkerBalanceInOutDataTable.vue";
import useSharedMethod from "@/use/SharedMethod";
import axios from "axios";

export default {
    components: {WorkerBalanceInOutDataTable},
    props: {
        path: String,
        vacation: Boolean,
        start: String,
        end: String,
        startMonth: String,
        endMonth: String,
    },
    setup(props) {
        const {loading, filter, backgroundColor} = useSharedData();
        const {transformFilterValues} = useSharedMethod();
        const {paySlipPeriodicities} = useSharedSelectData();
        const {$router} = useTools();
        const workerBalanceStore = useWorkerBalanceStore();
        
        const {workerBalance} = storeToRefs(workerBalanceStore);
        
        const balanceInOuts = ref([]);
        const tab = ref(null);
        
        function findAll() {
            loading.value = true;
            filter.value.workerId = workerBalance.value.workerId;
            filter.value.balanceId = workerBalance.value.balanceId;
            filter.value.start = props.start;
            filter.value.end = props.end;
            filter.value.startMonth = props.startMonth;
            filter.value.endMonth = props.endMonth;
            filter.value.allRecords = true;
            axios.get('/balanceInOuts', {params: transformFilterValues(filter.value)}).then(response => {
                balanceInOuts.value = response.data.elements;
            }).finally(() => {
                loading.value = false;
            });
        }
        
        const firstTab = computed(() => balanceInOuts.value.filter(e => {
            let c1 = e.direction === 'IN' && (e.type === 'GATHERING' || e.type === 'MANUAL_GATHERING' || e.type === 'FILE' || e.type === 'INIT_BALANCE' || e.type === 'INIT_REMAINING');
            let c2 = e.direction === 'OUT';
            let c3 = e.waiting;
            return e.workerBalanceBalanceActivateConsolidation ? (c1 || c2) && !c3 : !c3;
            
        }));
        
        const secondTab = computed(() => balanceInOuts.value.filter(e => e.waiting));
        
        const selectedGatheringId = ref(null);
        const gatheringDetailsDialog = ref(false);
        const gatheringDetails = computed(() => {
            let r = [];
            balanceInOuts.value.forEach(e => {
                if (e.gatheringId === selectedGatheringId.value)
                    r.push(e);
            })
            return r;
        });
        
        function consult(item) {
            switch (item.type) {
                case "ABSENCE_REQUEST":
                    $router.push({name: `${props.path}.request.view`, params: {id: item.parentId}});
                    break;
                case "GATHERING":
                case "MANUAL_GATHERING":
                    selectedGatheringId.value = item.id;
                    gatheringDetailsDialog.value = true;
                    break;
                case "PAY_SLIP":
                    $router.push({name: `${props.path}.pay_slip.view`, params: {id: item.parentId}});
                    break;
            }
        }
        
        
        watch(() => workerBalance.value, () => {
            if (workerBalance.value.workerId && workerBalance.value.balanceId) {
                findAll();
            } else {
                balanceInOuts.value = [];
            }
        }, {immediate: true, deep: true});
        
        return {
            tab,
            loading,
            balanceInOuts,
            firstTab,
            secondTab,
            paySlipPeriodicities,
            filter,
            backgroundColor,
            workerBalance,
            gatheringDetailsDialog,
            gatheringDetails,
            findAll,
            consult,
        }
    }
};
</script>

<template>
    <div>
        <v-dialog
            v-model="gatheringDetailsDialog"
            scrollable
            max-width="1200"
        >
            <v-card>
                <v-card-text class="pa-0">
                    <v-container fluid>
                        <worker-balance-in-out-data-table
                            :records="gatheringDetails"
                            :loading="loading"
                            :vacation="vacation"
                            @consult="consult"
                        />
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-tabs
            dense
            height="35"
            color="teal"
            :background-color="backgroundColor"
        >
            <v-tab>{{ $t('common.details') }}</v-tab>
            <v-tab>{{ $t('balance.year_in_progress') }}</v-tab>
            <v-tab-item v-for="n in [1, 2]" :key="`tab-item-${n}`">
                <v-container fluid>
                    <worker-balance-in-out-data-table
                        :records="n === 1 ? firstTab : secondTab"
                        :loading="loading"
                        :vacation="vacation"
                        @consult="consult"
                    />
                </v-container>
            </v-tab-item>
        </v-tabs>
    </div>
</template>
